import React, { useState, useCallback } from 'react'
import Pagination from 'components/UI/Pagination'
import { List } from 'ui'

function usePagination(itemsPerPage = 10, raw, initialPage = 1) {
  // Set current page to first page
  const [currentPage, setCurrentPage] = useState(initialPage)
  // Set number of items to 0 until set outside of hook
  const [numberOfItems, setNumberOfItems] = useState(0)

  // Only show the pagination if there is more than one page of items.
  const pagination = itemsPerPage < numberOfItems && (
    <Pagination currentPage={currentPage} pageLength={itemsPerPage} numberOfItems={numberOfItems} onPageChange={newPage => setCurrentPage(newPage)} />
  )

  // Return a filter that changes when the currentPage or number of items per page changes.
  const filter = useCallback(
    () => ({
      count: numberOfItems,
      page: currentPage,
      limit: itemsPerPage
    }),
    [currentPage, itemsPerPage, numberOfItems]
  )

  // Returns the pagination element, the filter to use for the backend and a function to set the number of
  // items once we have received it from the backend (in the count field on the response)
  return [raw ? pagination : numberOfItems > itemsPerPage ? <List.Item>{pagination}</List.Item> : null, filter, setNumberOfItems, setCurrentPage]
}

export default usePagination
